import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

import routes from '../../routes'
import { Box, Text } from '../Shared/Base'
import { FormElementGlobalError } from '../Shared/Form/Element'
import { FocusableField, useFormState } from '../Shared/Form/Field'
import { FormTextFieldInput } from '../Shared/Form/Input'
import { valid_email, valid_required } from '../Shared/Form/validators'
import { useFetchApi } from '../Shared/hooks'
import LinkSafe from '../Shared/LinkSafe'

const form_config = {
  initial_values: { email: '' },
  validators: {
    email: { required: valid_required, is_email: valid_email }
  }
}

const SignPasswordForgot = () => {
  useEffect(() => {
    if (navigator.userAgent !== 'ReactSnap') {
      window.location.replace('/sign/in')
    }
  }, [])

  const [sent, set_sent] = React.useState(false)
  const location = useLocation()
  const fetcher = useFetchApi()
  const onSubmitSuccess = React.useCallback(
    async ({ email }) => {
      await fetcher('user/forgot-password', { method: 'POST', body: JSON.stringify({ email }) })
      set_sent(true)
    },
    [fetcher]
  )
  const form = useFormState({
    initial_values: form_config.initial_values,
    validators: form_config.validators,
    onSubmitSuccess
  })

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      width="100%"
      maxWidth={400}
      height="100vh"
      mx="auto"
      py={50}
      px={20}
    >
      <LinkSafe to={routes.homepage.route.reverse()}>
        <Box
          as="img"
          src="https://res.cloudinary.com/loueragile/image/upload/v1653311807/web/jinka/Logo-Jinka-a.svg"
          width={129}
          alt="Logo - Jinka"
          position={{ md: 'absolute', xs: 'absolute' }}
          top={{ md: 50, xs: 20 }}
          left={{ md: 50, xs: '50%' }}
          ml={{ md: 0, xs: '-80px' }}
        />
      </LinkSafe>
      <Box width="100%" textAlign="center">
        <Box
          as="p"
          className="h2-like"
          mb={50}
          pb={10}
          px={20}
          borderColor="n_tertiary"
          borderBottom="1px solid"
          textAlign="center"
          display="inline-block"
        >
          Mot de passe oublié
        </Box>
      </Box>

      {sent ? (
        <Box textAlign="center" mb={50}>
          Si votre adresse e-mail est associée à un compte, vous recevrez un e-mail avec vos
          identifiants.
        </Box>
      ) : (
        <Box as="form" onSubmit={form.onSubmit} onChange={form.onChange} width="100%">
          <FormElementGlobalError globalError={form.globalError} />
          <Box>
            <FocusableField
              showRequiredError={form.submittedOnce}
              label="E-mail"
              name="email"
              type="email"
              placeholder="Votre e-mail"
              value={form.values.email}
              validators={form.validators.email}
            >
              {FormTextFieldInput}
            </FocusableField>
          </Box>

          <Box
            as="button"
            className="btn is-n_secondary is-medium"
            mt={40}
            width="100%"
            disabled={form.loading}
          >
            Envoyer
          </Box>
        </Box>
      )}

      <Box mt={20} textAlign="center">
        <Link
          to={{
            pathname: routes.sign.route.reverse({ action: 'in' }),
            search: location.search
          }}
        >
          <Text color="n_tertiary" as="span" className="tdh">
            Se connecter
          </Text>
        </Link>
      </Box>
    </Box>
  )
}

export default SignPasswordForgot
